import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mui";
import { Alert, Stack, Typography } from "@mui/material";

import {
    DetailSection,
    FieldGrid,
    FieldItem,
    RelatedLink,
} from "components/detail";

export const PresentationShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;

    const record = data?.data;

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    설명회 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    설명회를 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        <FieldItem label="장소" value={record?.place} />
                        <FieldItem
                            label="내용"
                            span={2}
                            multiline
                            value={record?.content}
                        />
                        <FieldItem label="시작일" value={record?.startDate} />
                        <FieldItem label="종료일" value={record?.endDate} />
                        <FieldItem
                            label="목록"
                            value={
                                <RelatedLink
                                    to={`/ptDates?filters[0][field]=presentationId&filters[0][operator]=eq&filters[0][value]=${record?.id}`}
                                    label="바로가기"
                                />
                            }
                        />
                        <FieldItem label="수정일" value={record?.updatedDate} />
                    </FieldGrid>
                </DetailSection>
            </Stack>
        </Show>
    );
};
